<template>
  <div class="body" :style="{ backgroundImage: `url(${require('@/assets/flower-background.png')})` }">
    <div class="backdrop" />
    <div class="content d-flex flex-column justify-center align-center">
      <img :src="require('@/assets/CAVIN_Logo_white.png')" class ="mt-3" width="200px" />

      <span class="mt-3 welcome">{{ $t("welcome_back") }}</span>

      <v-card class="card d-flex flex-column justify-center align-center">
        <span class="card-title">{{ $t("login") }}</span>
        <p v-if="invalid" style="color: red;">{{ $t("login_error") }}</p>
        <div style="width: 100%;">
          <span class="label">{{ $t("email") }}</span>
          <v-text-field ref="email" type="text" v-model="content.email" @keyup="keyupHandler" :error="invalid" autofocus outlined />
        </div>

        <div class="mt-4" style="width: 100%;">
          <span class="label">{{ $t("password") }}</span>
          <v-text-field ref="password" :type="showPassword ? 'text' : 'password'" class="mb-0" v-model="content.password" @keyup="keyupHandler" outlined :error="invalid" />
        </div>

        <div class="checkbox">
          <v-checkbox :label="$t('show_pwd')" v-model="showPassword" class="ma-0" color="success" hide-details />
        </div>

        <div class="forgot_pwd">
          <span>{{ $t("forgot_pwd") }}</span>
          <router-link to="/forgot_pwd" class="link">{{ $t("here") }}</router-link>
        </div>

        <v-btn :class="`btn ${userType}`" @click="login">{{ $t("login_btn") }}</v-btn>
      </v-card>

      <!-- 郵便番号判定が機能が正常化次第に表示する -->
      <!-- <div v-if="!disabledSignUp" class="signup">
        {{ $t("signup") }}
        <router-link :to="`/users/area`" class="link" style="color: white">{{ $t("here") }}</router-link>
      </div> -->
    </div>

    <div v-if="isUnpaid" class="modal">
      <div class="modal-content">
        <div class="card dialog-card">
          <button class="close-btn" @click="closeUnpaidDialog()">
            <img class="close-img" :src="require('@/assets/close_modal.svg')"/>
          </button>
          <div class="dialog-desc">
            <p class="dialog-text">{{ $t("login_limit_message1") }}</p>
            <p class="dialog-text">{{ $t("login_limit_message2") }}</p>
          </div>
          <a :href="contactLineUrl">
            <MstButton class="btn bg-secondary" color="#173169">{{ $t("line_contact") }}</MstButton>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MstButton } from "@/components/master";

export default {
  components: {
    MstButton
  },
  props: {
    type: String,
  },
  data() {
    return {
      showPassword: false,
      invalid: false,
      content: {},
      isUnpaid: false
    };
  },
  async mounted() {
    this.$refs.email.focus();

    this.confirmationToken = this.$route.query.confirmation_token;

    if (this.confirmationToken) {
      const { result } = await this.$api.post(
        "/users/confirm",
        {
          user: {
            confirmation_token: this.confirmationToken
          }
        },
        {
          headers: {
            X_CLIENT_ID: process.env.VUE_APP_X_CLIENT_ID,
            X_CLIENT_SECRET: process.env.VUE_APP_X_CLIENT_SECRET
          }
        }
      );

      if (result.errors) {
        this.$router.push("/users/error");
      } else {
        this.$store.commit("setData", {
          is_confirmed: true
        });
      }
    }
  },
  computed: {
    userType() {
      const map = {
        Farm: "orange",
        Shop: "green",
        Driver: "pink",
      };
      return map[this.type];
    },
    disabledSignUp() {
      return this.type === "Driver";
    },
    contactLineUrl() {
      return process.env.VUE_APP_X_OFFICIAL_LINE_URL;
    }
  },
  methods: {
    keyupHandler(e) {
      if (e.key === "Enter") this.login();
    },
    login() {
      const { email, password } = this.content;

      if (!email) {
        this.$refs.email.focus();
        return;
      }

      if (!password) {
        this.$refs.password.focus();
        return;
      }

      this.$store.dispatch("login", { email, password }).then(res => {
        if (res) {
          if (res.unpaid) {
            this.isUnpaid = true;
          } else {
            this.invalid = false;
            sessionStorage.setItem("isSignedInRecently", true);
            this.$router.push(`/${res.toLowerCase()}`);
          }
        } else {
          this.invalid = true;
        }
      });
    },
    closeUnpaidDialog() {
      this.isUnpaid = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.body {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  width: 100vw;
  height: 100vh;
}

.backdrop {
  background-color: #333333;
  opacity: 0.8;
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 0;
}

.content {
  position: absolute;
  z-index: 1;
  width: 100vw;
  height: 100vh;
}

.welcome {
  font: Bold 1rem Helvetica;
  color: #ffffff;
}

@media only screen and (max-width: 600px) {
  $width: 90%;
  .card {
    padding: 2rem;
    width: $width;
  }
  .signup {
    width: $width;
  }

  .forgot_pwd {
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }
}

@media only screen and (min-width: 600px) {
  $width: 40rem;
  .card {
    padding: 2rem 4rem 2rem 4rem;
    width: $width;
  }

  .signup {
    width: $width;
  }

  .forgot_pwd {
    text-align: left;
    margin-top: -1.5rem;
    margin-bottom: 2rem;
  }
}

.card {
  margin-top: 2.5rem;
}

.signup {
  font: Bold 1rem Helvetica;
  text-align: left;
  color: #ffffff;
}

.forgot_pwd {
  width: 100%;
  font: Regular 0.8rem Helvetica;
  color: #777777;
  display: none;
}

.card-title {
  font: Bold 1.5rem Helvetica;
  color: #333333;
}

.label {
  font: Medium 1rem Noto Sans CJK JP;
  color: #111111;
}

.link {
  cursor: pointer;
  color: #3794e3;
  text-decoration: underline;
}

.checkbox {
  margin-top: -30px;
  margin-left: auto;
  color: #979797;
  font: SemiBold 14px/18px Muli;
}

.btn {
  width: 200px;
}
.dialog-card {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 234px;
  width: 344px;
  margin: auto;
}
.card-logo {
  width: 42px;
  height: 46.67px;
  margin: auto;
  margin-top: 12px;
  margin-bottom: 12px;
}
.dialog-header {
  margin: auto;
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: bold;
}
.dialog-desc {
  margin: 16px 0px;
}
.dialog-text {
  font-size: 16px;
  margin-bottom: 0px;
}
.flex-items {
  display: flex;
  gap: 10px;
}
.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}
.modal-content {
  background-color: #fefefe;
  margin: auto;
  border: 0 solid #888;
  border-radius: 8px;
  max-width: 344px;
}
.close-btn {
  display: flex;
  flex-direction: row-reverse;
  margin: 5px;
}
.close-img {
  position: relative;
}
</style>
